import { render, staticRenderFns } from "./AdminDepartmentBaseForm.vue?vue&type=template&id=2c5df127&"
import script from "./AdminDepartmentBaseForm.vue?vue&type=script&lang=ts&"
export * from "./AdminDepartmentBaseForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSeparator});
